
<template>
    <div>
        <div>
            <div class="col-lg-12" v-if="isLoadingBlade">
                <div class="d-flex justify-content-center">
                    <img :src="loadingBladeUrl" />
                </div>
            </div>

            <div v-if="! showPaymentPage">
                <div class="container" v-if="! isLoadingBlade">
                    <hr>
                    <div class="row">
                        <div class="col-lg-6">
                            <base-input alternative=""
                                label="Title"
                                input-classes="form-control-alternative"
                                placeholder="Enter Title"
                                v-model="record.title"
                                required
                            />
                        </div>

                        <div class="col-lg-6">
                            <base-input alternative=""
                                label="Description"
                                input-classes="form-control-alternative"
                                placeholder="Enter Description"
                                v-model="record.description"
                            />
                        </div>
                    </div>
                </div>

                <base-alert :type="errorType" dismissible v-if='showErrorStatus && ! isLoadingBlade'>
                    <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                    <span class="alert-inner--text">
                        {{errorMsg}}
                    </span>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </base-alert>

                <hr>
                <div class="pl-lg-4">
                    <base-button
                        type="success"
                        @click="addBatch()"
                        :disabled="(privileges && privileges.add == 'no') || ! privileges || isloading"
                    >
                        <i class="fa fa-save" @if='! isloading'></i>
                        {{isloading ? 'Please Wait' : (data ? 'Update' : 'Save')+' Type'}}
                    </base-button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import moment from 'moment';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'AddAssessmentType',
        props: ['privileges', 'data', 'displayAddPage', 'changeTitle', 'loadAssessmentTypes'],
        data() {
            return {
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isLoadingBlade: false,
                record: {
                    title: null,
                    description: null
                },
                showPaymentPage: false,
                isloading: false
            }
        },
        filters: {
            formatDate(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            },
        },
        computed: {
            ...mapGetters(['menus', 'loadingBladeUrl', 'user']),
            years() {
                let startYear = moment().format('YYYY') - 2;// start from 1900
                let currentYear = parseInt(moment().format('YYYY'));
                let years = [];
                for (let i = currentYear; i > startYear; i-- ) {
                    years.push(i);
                }
                return years;
            }
        },
        methods: {
            ...mapActions(['addAssessmentType']),
            setData() {
                this.emptyFields();
                let type = this.data;
                if(type && type.id) {
                    this.record = {
                        id: type.id,
                        title: type.title,
                        description: type.description,
                    };
                }
            },
            addBatch() {
                this.isloading = true;
                this.preloader();// show loading
                let status = this.validatedData();// valid input data
                if(status) {// add to sanction list
                    this.record.admin_id = this.user.id;// add admin id
                    this.addAssessmentType(this.record).then((res) => {
                        this.loadAssessmentTypes();
                        this.isloading = false;
                        swal.close();
                        if(res.status) {
                            this.emptyFields();
                            this.displayAddPage(false);
                            swal.fire("Type Updated!", res.msg, "success");
                        } else {
                            swal.fire("Error Ocurred!", res.msg, "warning");
                        }
                    }).
                    catch(err => {
                        this.loadAssessmentTypes();// refresh page
                        swal.fire(err.message+"!", "An error occurred while updating, try again", "warning");
                    });
                }   else {
                    this.isloading = false;
                    swal.close();
                }
            },
            emptyFields() {
                return this.record = {
                    title: null,
                    description: null
                };
            },
            validatedData() {
                let data = this.record;
                data.title != null ? data.title : this.showInuptError('Title');
                let status = data.title;
                return status ? true : false;
            },
            showInuptError(name) {
                this.isloading = false;
                this.showErrorStatus = true
                this.errorType = 'warning'
                this.errorMsg = 'Invalid ' + name + ' has been entered';
                var self = this;
                setTimeout(function() { self.showErrorStatus = false; }, 5000);
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        },
        mounted() {
            this.setData();
        }
    };
</script>
<style>
    .table td {
        font-size: 15px;
    }
    .form-control-label {
        width: 100%;
    }
</style>
